import { createContext, useContext, useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { getIcon } from "@/data/icons";

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [ready, setReady] = useState(false);

  const refreshCategories = useCallback(async () => {
    const { data } = await api.get("/categories");
    setCategories(data);
    return data;
  }, []);

  const refreshMemberships = useCallback(async () => {
    const { data } = await api.get("/memberships");
    setMemberships(data);
    return data;
  }, []);

  useEffect(() => {
    Promise.all([refreshCategories(), refreshMemberships()]).finally(() => setReady(true));
  }, [refreshCategories, refreshMemberships]);

  const getCategory = useCallback(
    (slug) => {
      const c = categories.find((x) => x.slug === slug);
      if (c) return { ...c, icon: getIcon(c.icon) };
      return { slug, label: slug, icon: getIcon("Store"), color: "#5C5C5C" };
    },
    [categories]
  );

  const getMembership = useCallback(
    (id) => memberships.find((m) => m.id === id) || null,
    [memberships]
  );

  // categories with resolved icon components for rendering
  const categoriesResolved = categories.map((c) => ({ ...c, Icon: getIcon(c.icon) }));

  return (
    <DataContext.Provider
      value={{
        categories,
        categoriesResolved,
        memberships,
        ready,
        getCategory,
        getMembership,
        refreshCategories,
        refreshMemberships,
      }}
    >
      {children}
    </DataContext.Provider>
  );
}

export const useData = () => useContext(DataContext);
